export const getUpdateInfos = ({ id, isChipActive, level, slug }) => {
    const isMissingCategoryParam = !id || !level || !slug;
    /**
     * If the Chip is active then we know we are already on inCategorySearch page
     * thus we need to go back to the search page on click
     */
    if (isChipActive || isMissingCategoryParam)
        return {
            refinement: undefined,
            listingData: {
                type: 'search',
                category: {},
            },
        };
    return {
        refinement: {
            id,
            level,
            url: `/filter/${slug}`,
        },
        listingData: {
            type: 'category',
            category: {
                id,
                level,
            },
        },
    };
};

export default {
    getUpdateInfos,
};
